var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 137.504,
    viewBox: "0 0 150 137.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1201",
    "data-name": "Rectangle 1201",
    width: 150,
    height: 137.504,
    fill: "#212330"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Drag_PNG_files_here",
    "data-name": "Drag PNG files here",
    opacity: 0.2,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M39.059,213.65a23.4,23.4,0,0,1-22.138-15.944l-.218-.719a22.811,22.811,0,0,1-1.082-6.775V147.6L.459,198.212a14.194,14.194,0,0,0,9.95,17.219l96.646,25.883a14.345,14.345,0,0,0,3.6.462,13.936,13.936,0,0,0,13.506-10.22l5.631-17.906Z",
    transform: "translate(0 -104.272)",
    fill: "#212330"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M161.533,88.878a12.5,12.5,0,1,0-12.5-12.5,12.512,12.512,0,0,0,12.5,12.5",
    transform: "translate(-105.285 -45.126)",
    fill: "#212330"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M194.533,0H100.781A15.648,15.648,0,0,0,85.156,15.626V84.377A15.648,15.648,0,0,0,100.781,100h93.752a15.648,15.648,0,0,0,15.626-15.626V15.626A15.648,15.648,0,0,0,194.533,0M100.781,12.5h93.752a3.126,3.126,0,0,1,3.125,3.125V60L177.915,36.957a11.2,11.2,0,0,0-8.382-3.843,10.925,10.925,0,0,0-8.35,3.944L137.969,64.921l-7.563-7.544a10.971,10.971,0,0,0-15.5,0L97.657,74.621V15.626a3.126,3.126,0,0,1,3.124-3.125",
    transform: "translate(-60.159)",
    fill: "#212330"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSelect);
export default __webpack_public_path__ + "static/media/ImageSelect.944dc558fb37a9ef30dfef13df1afa00.svg";
export { ForwardRef as ReactComponent };